import { z } from "zod";
// Ops-admin wire contracts for lifecycle email (ADR-0033): the template
// catalogue, a rendered preview, and a test send. Same audience as the
// integrations admin surface.
export const OperationsEmailTemplateSummary = z.object({
    kind: z.string(),
    category: z.string(),
    /** Rule description, so an operator can see what triggers this email. */
    trigger: z.string(),
    subject: z.string(),
    preheader: z.string(),
});
export const OperationsEmailConfigStatus = z.object({
    /** `mailgun` or `log`. `log` delivers nothing. */
    provider: z.string(),
    /** True when the provider can actually reach an inbox. */
    canDeliver: z.boolean(),
    /** Mailgun accepts and validates but does not deliver. */
    testMode: z.boolean(),
    fromAddress: z.string(),
    /** Named config that is missing, so the dashboard can say what to set. */
    missing: z.array(z.string()),
    /** Whether an address can be resolved from identity at all. */
    recipientLookupConfigured: z.boolean(),
});
export const OperationsEmailTemplatesResponse = z.object({
    templates: z.array(OperationsEmailTemplateSummary),
    config: OperationsEmailConfigStatus,
    /** Per-kind, per-status send counts from the ledger. */
    counts: z.array(z.object({ kind: z.string(), status: z.string(), count: z.number() })),
});
export const OperationsEmailPreviewQuery = z.object({
    kind: z.string().min(1).max(80),
    /** Sample first name. Empty exercises the no-name greeting. */
    firstName: z.string().max(80).optional(),
    /** Sample days-inactive for the lapsed template. */
    daysInactive: z.coerce.number().int().min(0).max(365).optional(),
});
export const OperationsEmailPreviewResponse = z.object({
    kind: z.string(),
    subject: z.string(),
    preheader: z.string(),
    html: z.string(),
    text: z.string(),
});
export const OperationsEmailTestSendRequest = z.object({
    kind: z.string().min(1).max(80),
    /**
     * Where to send. Explicit rather than derived from the caller, so an operator
     * can check rendering in a client they do not personally use. Never a member
     * address: this endpoint takes a literal address and does no member lookup.
     */
    to: z.string().email(),
    firstName: z.string().max(80).optional(),
    daysInactive: z.coerce.number().int().min(0).max(365).optional(),
});
export const OperationsEmailTestSendResponse = z.object({
    status: z.enum(["sent", "failed"]),
    provider: z.string(),
    providerMessageId: z.string().nullable(),
    /** Present when status is failed. Addresses are masked. */
    reason: z.string().nullable(),
});
//# sourceMappingURL=operations-email.js.map